// Bundle ATC helper. Caller builds the items array (with _bundle_* line
// item properties); this handles the cart write + cart-drawer dispatch.
(function () {
  'use strict';

  // Throws on non-OK; caller handles loading state and logging.
  async function submit(items) {
    const url =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items: items }),
    });

    if (!response.ok) {
      const data = await response.json().catch(function () {
        return {};
      });
      throw new Error(
        data.description || data.message || 'cart/add failed'
      );
    }

    document.dispatchEvent(new CustomEvent('nova:cart:refresh'));
    document.dispatchEvent(new CustomEvent('nova:cart:open'));
  }

  window.wfhBundleAtc = { submit: submit };
})();
